// ABOUTME: The storm row the petal screen settles on: storm clouds and rain at the left, a dry sun breaking through at the right.
// ABOUTME: One panel as wide as the viewport; the round's sky strip ends on this same picture, so the countdown's 0:00 is the settled frame.

import { Box } from '@mui/material';
import { CROSSING_BREATH_SUN, CROSSING_STORM_SKY_GLOW, CROSSING_STORM_VEIL_DROP } from '../../../theme/crossingTokens';
import { CLOUD_SHAPES, STORM_LAYER_CLOUDS, motion, pvRainVeil } from './stormSkyParts';

// Each cloud's centre, as a fraction of the panel, in STORM_LAYER_CLOUDS order: all in the left half, whatever the width.
const CLOUD_CENTRES = ['30%', '18%', '36%', '8%'];
// The rain falls only under the left clouds, and its skewed box stays left of the canoe at the centre on a phone as well as a desktop.
const DROPS_WIDTH = '34%';

interface StormHorizonProps {
  reducedMotion?: boolean;
}

// Fills its parent, which is a box SKY_PANEL_W wide and as tall as the sky.
export default function StormHorizon({ reducedMotion = false }: StormHorizonProps) {
  return (
    <>
      <Box
        data-testid="breath-storm-layer-glow"
        sx={{ position: 'absolute', left: '56%', top: '-10%', width: '44%', height: '120%', background: CROSSING_STORM_SKY_GLOW }}
      />
      <Box
        data-testid="breath-horizon-sun"
        sx={{ position: 'absolute', left: '76%', top: '18%', width: '60px', height: '60px', borderRadius: '50%', background: CROSSING_BREATH_SUN }}
      />
      <Box
        data-testid="breath-storm-layer-veil"
        sx={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, transform: 'skewX(-12deg)' }}
      >
        <Box
          data-testid="breath-storm-layer-drops"
          sx={{
            position: 'absolute', left: 0, width: DROPS_WIDTH, top: 0, bottom: 0,
            backgroundImage: `radial-gradient(ellipse 1px 6px at 50% 50%, ${CROSSING_STORM_VEIL_DROP} 96%, transparent 100%)`, backgroundSize: '16px 34px',
            maskImage: 'linear-gradient(90deg, black 0%, black 55%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(90deg, black 0%, black 55%, transparent 100%)',
            animationName: motion(pvRainVeil, reducedMotion), animationDuration: '1.5s', animationTimingFunction: 'linear', animationIterationCount: 'infinite',
          }}
        />
      </Box>
      {STORM_LAYER_CLOUDS.map((cloud, index) => (
        <Box
          key={cloud.fill}
          data-testid="breath-storm-layer-cloud"
          style={{ opacity: cloud.opacity }}
          sx={{ position: 'absolute', left: CLOUD_CENTRES[index], top: cloud.top, width: `${cloud.width}px`, height: `${cloud.height}px`, transform: 'translateX(-50%)' }}
        >
          {CLOUD_SHAPES.map(shape => (
            <Box key={shape.left} sx={{ position: 'absolute', ...shape, background: cloud.fill }} />
          ))}
        </Box>
      ))}
    </>
  );
}
